import React, { useEffect } from "react";
import ChairCustom from "./ChairModel";
import "./styles-chair-scene.scss";
import { useInView } from "react-intersection-observer";
import { motion, useAnimation } from "framer-motion";
//
import ChairContext from "../../../UseContextChairHandlers";
import ColorsChairContext from "../../../useContextColorsChair";
import { useContext } from "react";

import { FiMoreHorizontal } from "react-icons/fi";
//
const ChairPropCustom = () => {
  const { ref, inView } = useInView();
  const animDescriptionTitleChair = useAnimation();
  const animDescriptionIconsColorChair = useAnimation();

  const {
    onCrocoTexture,
    handleCrocoTexture,
    onMatFabric,
    handlerMatFabric,
    onGlossyTexture,
    handlerGlossy,
  } = useContext(ChairContext);

  const {
    handleColorCrocoChair,
    handleColorChange,

    currentsColorBg,
  } = useContext(ColorsChairContext);

  useEffect(() => {
    if (inView) {
      animDescriptionTitleChair.start({
        y: 0,
        opacity: 1,
        transition: {
          delay: 0.2,
          type: "spring",
          duration: 1.8,
          damping: 12,
        },
      });

      animDescriptionIconsColorChair.start({
        y: 0,
        opacity: 1,
        transition: {
          type: "spring",
          duration: 1,
          damping: 13,
          delay: 0.4,
        },
      });
    }

    if (!inView) {
      animDescriptionTitleChair.start({
        y: 350,
        opacity: 0,
      });
      animDescriptionIconsColorChair.start({
        y: 350,
        opacity: 0,
      });
    }
    //
  }, [inView]);
  //
  return (
    <>
      <motion.div className="wrapper-sceneChairComponent" ref={ref}>
        <div className="container-scene-chair">
          <div id="scene__Chair">
            <div className="container___chairScene">
              <div className="wrapper__chair-Customized">
                <motion.div
                  className="chair-animatedOverlay"
                  animate={
                    onCrocoTexture
                      ? {
                          backgroundColor: "rgb(221, 227, 231)",

                          x: 0,
                          opacity: 1,
                        }
                      : {}
                  }
                  initial={{
                    backgroundColor: currentsColorBg,
                    x: -1500,
                    opacity: 0,
                  }}
                  exit={{ opacity: 0, x: -1500 }}
                  //
                  transition={{
                    duration: 2,
                    delay: 0.2,
                    ease: [0.6, 0.01, -0.05, 0.95],
                  }}
                />

                <ChairCustom />

                <motion.div
                  animate={animDescriptionTitleChair}
                  id="chair_titleLg"
                  //
                  className={
                    onCrocoTexture
                      ? "is--crocoFontWhite"
                      : onMatFabric
                      ? "is--crocoFontBlack"
                      : ""
                  }
                >
                  {onCrocoTexture ? (
                    <h1>lore:</h1>
                  ) : onMatFabric ? (
                    <h1>adem:</h1>
                  ) : onGlossyTexture ? (
                    <h1>roda:</h1>
                  ) : (
                    <h1>fluxus:</h1>
                  )}

                  {onCrocoTexture ? (
                    <span className="chairNameTitle"> summer collection </span>
                  ) : onMatFabric ? (
                    <span className="chairNameTitle"> winter collection </span>
                  ) : onGlossyTexture ? (
                    <span className="chairNameTitle"> classic collection </span>
                  ) : (
                    <span className="chairNameTitle"> new 2022</span>
                  )}
                </motion.div>

                <motion.div
                  animate={animDescriptionIconsColorChair}
                  className="wrapper__chair__description"
                >
                  <motion.div
                    style={
                      onCrocoTexture
                        ? {
                            backgroundColor: "rgb(221, 227, 231)",
                          }
                        : { borderColor: "#141414" }
                    }
                    className="container__chair__description"
                  >
                    <motion.div className="chair_description__data_top">
                      {onCrocoTexture ? (
                        <h1>
                          Current:
                          <span className="titleDescript_data-top">Lore</span>
                        </h1>
                      ) : (
                        <h1>
                          SS/<span className="titleDescript_data-top"> 22</span>
                        </h1>
                      )}

                      <button
                        style={
                          onCrocoTexture
                            ? {
                                color: "#141414",
                              }
                            : {}
                        }
                        onClick={handleCrocoTexture}
                        className="btn-colors-croco-dashboard"
                      >
                        <FiMoreHorizontal />
                      </button>
                    </motion.div>

                    <div className="container_custom_icon-data-bottom">
                      {onCrocoTexture ? (
                        <div className="icons_Description__chair">
                          <motion.div
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.9 }}
                            transition={{
                              type: "spring",
                              stiffness: 100,
                              damping: 12,
                            }}
                            className="chair_description_top_icon"
                          >
                            <motion.button
                              //
                              style={{
                                backgroundColor: "#aaaaaa",
                              }}
                              onClick={(event) =>
                                handleColorCrocoChair(event, "blackLeather")
                              }
                              //

                              //
                              className="icon-file-chair"
                            ></motion.button>
                          </motion.div>
                          <div className="chair_description_top_icon">
                            <button
                              style={{ backgroundColor: "#dd7f1a" }}
                              onClick={(event) =>
                                handleColorCrocoChair(
                                  event,
                                  "burntSiennaMediumDark"
                                )
                              }
                              className="icon-file-chair"
                            ></button>
                          </div>
                          <div className="chair_description_top_icon">
                            <button
                              style={{ backgroundColor: "#768b03" }}
                              onClick={(event) =>
                                handleColorCrocoChair(event, "greenMediumDark")
                              }
                              className="icon-file-chair"
                            ></button>
                          </div>
                        </div>
                      ) : (
                        " "
                      )}
                    </div>

                    <motion.div className="chair_description__data_top">
                      {onMatFabric ? (
                        <h1>
                          Current:
                          <span className="titleDescript_data-top">Adem</span>
                        </h1>
                      ) : (
                        <h1>
                          AW/<span className="titleDescript_data-top"> 22</span>
                        </h1>
                      )}

                      <button
                        style={
                          onCrocoTexture
                            ? {
                                color: "#141414",
                              }
                            : {}
                        }
                        onClick={handlerMatFabric}
                        className="btn-colors-croco-dashboard"
                      >
                        <FiMoreHorizontal />
                      </button>
                    </motion.div>

                    <div className="container_custom_icon-data-bottom">
                      {onMatFabric ? (
                        <div className="icons_Description__chair">
                          <div className="chair_description_top_icon">
                            <button
                              style={{
                                backgroundColor: "#dd7f1a",
                              }}
                              onClick={(event) =>
                                handleColorChange(event, "burntSienna")
                              }
                              className="icon-file-chair"
                            ></button>
                          </div>
                          <div className="chair_description_top_icon">
                            <button
                              style={{ backgroundColor: "#D0D473" }}
                              onClick={(event) =>
                                handleColorChange(event, "oliveGreen")
                              }
                              className="icon-file-chair"
                            ></button>
                          </div>
                          <div className="chair_description_top_icon">
                            <button
                              style={{ backgroundColor: "#768b03" }}
                              onClick={(event) =>
                                handleColorChange(event, "mossGreen")
                              }
                              className="icon-file-chair"
                            ></button>
                          </div>
                        </div>
                      ) : (
                        " "
                      )}
                    </div>

                    <div className="chair_description__data_top">
                      {onGlossyTexture ? (
                        <h1>
                          Current:
                          <span className="titleDescript_data-top">Roda</span>
                        </h1>
                      ) : (
                        <h1>NEW</h1>
                      )}
                      <button
                        style={
                          onCrocoTexture
                            ? {
                                color: "#141414",
                              }
                            : {}
                        }
                        onClick={handlerGlossy}
                        className="btn-colors-croco-dashboard"
                      >
                        <FiMoreHorizontal />
                      </button>
                    </div>

                    <div className="container_custom_icon-data-bottom">
                      {onGlossyTexture ? (
                        <div className="icons_Description__chair">
                          <div className="chair_description_top_icon">
                            <button
                              style={{
                                backgroundColor: "#dd7f1a",
                              }}
                              onClick={(event) =>
                                handleColorChange(event, "burntSienna")
                              }
                              className="icon-file-chair"
                            ></button>
                          </div>
                          <div className="chair_description_top_icon">
                            <button
                              style={{ backgroundColor: "#D0D473" }}
                              onClick={(event) =>
                                handleColorChange(event, "oliveGreen")
                              }
                              className="icon-file-chair"
                            ></button>
                          </div>
                          <div className="chair_description_top_icon">
                            <button
                              style={{ backgroundColor: "#768b03" }}
                              onClick={(event) =>
                                handleColorChange(event, "mossGreen")
                              }
                              className="icon-file-chair"
                            ></button>
                          </div>
                        </div>
                      ) : (
                        " "
                      )}
                    </div>
                  </motion.div>
                </motion.div>
              </div>
              {/*  */}
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default ChairPropCustom;
